import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { ValueFromArrayPipe } from '@product/shared/pipes/ValueFromArray.pipe';
import { ProductFieldDateComponent } from '@product/shared/layout/product-field/product-field-date/product-field-date.component';
import { ProductFieldTimeComponent } from '@product/shared/layout/product-field/product-field-time/product-field-time.component';
import { ProductFieldTextComponent } from '@product/shared/layout/product-field/product-field-text/product-field-text.component';
import { ProductFieldHtmlComponent } from '@product/shared/layout/product-field/product-field-html/product-field-html.component';
import { ProductFieldMultiselectComponent } from '@product/shared/layout/product-field/product-field-multiselect/product-field-multiselect.component';
import { ProductFieldRelationComponent } from '@product/shared/layout/product-field/product-field-relation/product-field-relation.component';
import { ProductFieldSelectComponent } from '@product/shared/layout/product-field/product-field-select/product-field-select.component';
import { ProductFieldNumberComponent } from '@product/shared/layout/product-field/product-field-number/product-field-number.component';
import { ProductFieldStringComponent } from '@product/shared/layout/product-field/product-field-string/product-field-string.component';

import { PageHeaderComponent } from './base/page-header/page-header.component';
import { FilterSideBarComponent } from './base/filter-side-bar/filter-side-bar.component';
import { EditInPlaceComponent } from '../EditInPlace/EditInPlace.component';

import { CustomAttributesComponent } from '../forms/custom-attributes/custom-attributes.component';
import { ProductFieldComponent } from '@product/shared/layout/product-field/product-field.component';
import { FormControlGetterPipe } from '@product/shared/pipes/form-control-getter.pipe';
import { StringSeparatorPipe } from '@product/shared/pipes/string-separator.pipe';
import { NgZorroModule } from '../ng-zorro.module';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { ReactiveFormsModule } from '@angular/forms';
import { NgxSummernoteModule } from 'ngx-summernote';
import { Safe } from '@app/shared/pipes/safeHtml.pipe';
import { AttributesGroupFieldsPipe } from '@product/shared/pipes/attributes-group-fields.pipe';
import { ListColumnSelectorComponent } from './base/list-column-selector/list-column-selector.component';
import { MediaComponent } from '../Media/Media.component';
import { MediaHolderComponent } from '../MediaHolder/MediaHolder.component';
import { ExtendedMediaHolderComponent } from './extended-media-holder/extended-media-holder.component';
import { NzImageService } from 'ng-zorro-antd/image';
import { GetChannelByIdPipe } from './pipes/get-channel-by-id.pipe';
import { FormCategoryComponent } from '../forms/category/category.component';
import { CategoriesComponent } from '@product/shared/layout/groups/categories/categories.component';
import { ConfigurableProductComponent } from '@product/shared/layout/groups/configurable-product/configurable-product.component';
import { GroupedProductComponent } from '@product/shared/layout/groups/grouped-product/grouped-product.component';
import { IsNumberPipe } from './pipes/IsNumber.pipe';
import { AnchorComponent } from './anchor/anchor.component';
import { CamelCaseSeparatorPipe } from './pipes/camel-case-separator.pipe';
import { ProductFieldBooleanComponent } from '@product/shared/layout/product-field/product-field-boolean/product-field-boolean.component';
import { ProductsTableComponent } from '@product/list/products-table/products-table.component';
import { BooleanFilterComponent } from '@product/shared/layout/filter-components/boolean-filter/boolean-filter.component';
import { DateFilterComponent } from '@product/shared/layout/filter-components/date-filter/date-filter.component';
import { FilterBaseComponent } from '@product/shared/layout/filter-components/filter-base/filter-base.component';
import { NumberFilterComponent } from '@product/shared/layout/filter-components/number-filter/number-filter.component';
import { SelectFilterComponent } from '@product/shared/layout/filter-components/select-filter/select-filter.component';
import { TextFilterComponent } from '@product/shared/layout/filter-components/text-filter/text-filter.component';
import { StringSplitPipe } from '@product/shared/pipes/string-split.pipe';
import { AttributeDropDownValuePipe } from '@product/shared/pipes/attribute-dropdown-value.pipe';
import { LocalePipe } from '@product/shared/pipes/Locale.pipe';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { IsAuthorizedDirective } from './directives/is-authorized.directive';
import { IsNotAuthorizedDirective } from './directives/is-not-authorized.directive';
import { RelatedProductsComponent } from './templates/related-products/related-products.component';
import { ProductIntegrationsComponent } from '@product/shared/layout/product-integrations/product-integrations.component';
import { SyncListComponent } from './templates/sync-list/sync-list.component';
import { BulkEditFieldComponent } from '@app/bulk-edit/bulk-edit-field/bulk-edit-field.component';
import { AsFormGroupPipe } from './pipes/as-form-group.pipe';
import { FieldValidatorPipe } from '@product/shared/pipes/field-validator.pipe';
import { ColumnWidthPipe } from './pipes/column-width.pipe';
import { AttributeNamePipe } from '@product/shared/pipes/attribute-name.pipe';
import { AttributesToFieldPipe } from '@product/shared/pipes/attribute-to-field.pipe';
import { ObserveVisibilityDirective } from '@app/directives/visible-on-scroll.directive';
import { ProductSelectorComponent } from '@product/product-selector/product-selector.component';
import { CatalogSharedModule } from '@app/product-catalog/CatalogShared.module';
import { OperationTypePipe } from '@product/shared/pipes/operationType.pipe';
import { TranslateModule } from '@ngx-translate/core';
import { LanguageNamePipe } from '@product/shared/pipes/language-name.pipe';

@NgModule({
  providers: [NzImageService],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    NgZorroModule,
    NgxSummernoteModule,
    RouterModule,
    DragDropModule,
    CatalogSharedModule,
    TranslateModule
  ],
  declarations: [
    ProductSelectorComponent,
    ColumnWidthPipe,
    FieldValidatorPipe,
    BulkEditFieldComponent,
    RelatedProductsComponent,
    IsAuthorizedDirective,
    IsNotAuthorizedDirective,
    EditInPlaceComponent,
    LocalePipe,
    CamelCaseSeparatorPipe,
    AnchorComponent,
    IsNumberPipe,
    CategoriesComponent,
    ConfigurableProductComponent,
    GroupedProductComponent,
    AttributesGroupFieldsPipe,
    AttributesToFieldPipe,
    ValueFromArrayPipe,
    FormControlGetterPipe,
    StringSeparatorPipe,
    ProductFieldComponent,
    ProductFieldStringComponent,
    ProductFieldNumberComponent,
    ProductFieldSelectComponent,
    ProductFieldDateComponent,
    ProductFieldBooleanComponent,
    ProductFieldTimeComponent,
    ProductFieldTextComponent,
    ProductFieldHtmlComponent,
    ProductFieldMultiselectComponent,
    ProductFieldRelationComponent,
    FilterBaseComponent,
    TextFilterComponent,
    DateFilterComponent,
    SelectFilterComponent,
    StringSplitPipe,
    AttributeNamePipe,
    NumberFilterComponent,
    BooleanFilterComponent,
    CustomAttributesComponent,
    PageHeaderComponent,
    FilterSideBarComponent,
    ListColumnSelectorComponent,
    MediaComponent,
    MediaHolderComponent,
    ExtendedMediaHolderComponent,
    Safe,
    GetChannelByIdPipe,
    FormCategoryComponent,
    AttributeDropDownValuePipe,
    ProductsTableComponent,
    ProductIntegrationsComponent,
    SyncListComponent,
    AsFormGroupPipe,
    ColumnWidthPipe,
    ObserveVisibilityDirective,
    OperationTypePipe,
    LanguageNamePipe,
  ],
  exports: [
    ProductSelectorComponent,
    ProductIntegrationsComponent,
    ListColumnSelectorComponent,
    AsFormGroupPipe,
    SyncListComponent,
    RelatedProductsComponent,
    IsAuthorizedDirective,
    IsNotAuthorizedDirective,
    EditInPlaceComponent,
    DragDropModule,
    CamelCaseSeparatorPipe,
    FormCategoryComponent,
    LocalePipe,
    CategoriesComponent,
    ConfigurableProductComponent,
    GroupedProductComponent,
    AttributesGroupFieldsPipe,
    AttributesToFieldPipe,
    NgxSummernoteModule,
    NgZorroModule,
    ValueFromArrayPipe,
    ProductFieldComponent,
    ProductFieldStringComponent,
    ProductFieldNumberComponent,
    ProductFieldSelectComponent,
    ProductFieldDateComponent,
    ProductFieldTimeComponent,
    ProductFieldTextComponent,
    ProductFieldHtmlComponent,
    ProductFieldMultiselectComponent,
    ProductFieldRelationComponent,
    FilterBaseComponent,
    TextFilterComponent,
    DateFilterComponent,
    SelectFilterComponent,
    StringSplitPipe,
    AttributeNamePipe,
    NumberFilterComponent,
    BooleanFilterComponent,
    AttributeDropDownValuePipe,
    CustomAttributesComponent,
    FormControlGetterPipe,
    StringSeparatorPipe,
    PageHeaderComponent,
    FilterSideBarComponent,
    MediaComponent,
    MediaHolderComponent,
    Safe,
    FormsModule,
    ReactiveFormsModule,
    ProductsTableComponent,
    BulkEditFieldComponent,
    FieldValidatorPipe,
    ObserveVisibilityDirective,
    OperationTypePipe,
    LanguageNamePipe
  ],
})
export class SharedModule {}
